import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { BetterRequestService } from '@services';

import { CoreService } from '../../../core/core.service';
import { EnvironmentService } from '../../../core/environment.service';
import { IEdiCredentialsPost, IEdiProvider, IEdiProviderSetting } from '../models/edi.model';

@Injectable({
    providedIn: 'root',
})
export class EdiService {
    private http = inject(HttpClient);
    private readonly betterRequestService = inject(BetterRequestService);
    private environmentService = inject(EnvironmentService);
    private coreService = inject(CoreService);

    /*
     */
    getEdiProviders(): Observable<IEdiProvider[]> {
        //const url = this.environmentService.getURL(true) + '/edi/providers';
        const url = this.environmentService.getURL(this.environmentService.appSettings.fakeServer) + '/edi/providers';
        return this.betterRequestService
            .withoutErrorHandler(
                this.http.get<IEdiProvider[]>(url, {
                    headers: this.environmentService.appSettings.headers,
                    observe: 'body',
                }),
            )
            .pipe(
                map((response) => {
                    this.environmentService.ediProviders = response;
                    return response;
                }),
                catchError(this.coreService.handleError),
            );
    }
    /*
    Ermittelt den mandantenspezifischen Provider
     */
    getEdiProvider(): Observable<IEdiProvider> {
        // const url = this.environmentService.getURL(true) + '/edi/provider';
        const url = this.environmentService.getURL(this.environmentService.appSettings.fakeServer) + '/edi/provider';
        return this.betterRequestService
            .withoutErrorHandler(
                this.http.get<IEdiProvider>(url, {
                    headers: this.environmentService.appSettings.headers,
                    observe: 'body',
                }),
            )
            .pipe(
                map((response) => {
                    this.environmentService.ediProvider = response;
                    return response;
                }),
                catchError(this.coreService.handleError),
            );
    }
    /*
    Prüft, ob EDI möglich ist
    RESPONSE: TRUE or FALSE
     */
    getEdiCredentials(): Observable<IEdiProviderSetting | null> {
        const url = this.environmentService.getURL(this.environmentService.appSettings.fakeServer) + '/edi/credentials';
        return this.http
            .get<IEdiProviderSetting>(url, {
                headers: this.environmentService.appSettings.headers,
                observe: 'body',
            })
            .pipe(
                map((response) => (response?.provider?.id ? response : null)),
                catchError(() => of(null)),
            );
    }

    saveEdiCredentials(setting: IEdiCredentialsPost, credentialsId?: number): Observable<IEdiProviderSetting> {
        //let url = '/mwsfake/rest/edi/credentials';
        let url = this.environmentService.getURL(this.environmentService.appSettings.fakeServer) + '/edi/credentials';
        if (!credentialsId || credentialsId === undefined) {
            url = url + '/create';
            return this.betterRequestService
                .withoutErrorHandler(
                    this.http.post<IEdiProviderSetting>(url, setting, {
                        headers: this.environmentService.appSettings.headers,
                        observe: 'body',
                    }),
                )
                .pipe(catchError(this.coreService.handleError));
        }
        url = url + '/modify/' + credentialsId;
        return this.betterRequestService
            .withoutErrorHandler(
                this.http.patch<IEdiProviderSetting>(url, setting, {
                    headers: this.environmentService.appSettings.headers,
                    observe: 'body',
                }),
            )
            .pipe(catchError(this.coreService.handleError));
    }

    deleteEdiCredentials(credentialsId: number): Observable<boolean> {
        const url = this.environmentService.getURL(this.environmentService.appSettings.fakeServer) + '/edi/credentials/' + credentialsId;
        return this.betterRequestService
            .withoutErrorHandler(
                this.http.delete<boolean>(url, {
                    headers: this.environmentService.appSettings.headers,
                    observe: 'body',
                }),
            )
            .pipe(
                map(() => true),
                catchError(this.coreService.handleError),
            );
    }

    checkEdiProvider(): Observable<boolean> {
        //const url = this.environmentService.getURL(true) + '/edi/provider/check';
        const url = this.environmentService.getURL(this.environmentService.appSettings.fakeServer) + '/edi/provider/check';
        // WICHTIG hier ohne BetterRequestService, da die Anfrage im negativen Fall einen Fehler-Status 404 zurückliefert und der Service nicht 3x ausgeführt werden soll!
        return this.http
            .get<boolean>(url, {
                headers: this.environmentService.appSettings.headers,
                observe: 'body',
            })
            .pipe(
                map((response) => {
                    return response;
                }),
                catchError(() => of(false)),
            );
    }
}
